import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const q8: PartialCarConfiguration = {
	nextBestActions: [
		{
			description: 'Sök bilar i lager',
			icon: '',
			target: '_blank',
			labelText: 'Sök bilar i lager',
			trackingName: 'go to vtp',
			url: 'https://www.audi.se/se/web/sv/nya-audi/resultat.html#filter=carline.{{carlineId}}',
		},
	],
};

const q8etron = {
	...q8,
};
const q8sbetron = {
	...q8,
};
const sq8etron = {
	...q8,
};
const sq8sbetron = {
	...q8,
};
export { q8etron, q8sbetron, sq8etron, sq8sbetron };
